module.exports = __webpack_public_path__ + "static/media/sml2(1).0ab07872.png";